<div
  *ngIf="!hostLoglist?.LogList"
  class="d-flex justify-content-center align-items-center"
  style="height: 200px"
>
  <p style="margin: 0; font-size: 12px">No Log Details Available</p>
</div>

<div *ngIf="hostLoglist?.LogList" style="padding: 0.8%">
  <table class="table table-hover">
    <thead>
      <tr class="table-list-head"
        style="
          color: White;
          background-color: var(--s-primary-color);
          height: 2rem;
        "
      >
        <th>Group</th>
        <th>Link Count</th>
        <th>Owner</th>
        <th>Path</th>
        <th>Permissions</th>
        <th>Size</th>
        <th>Last Modified</th>
      </tr>
    </thead>
    <tbody>
      <tr class="table-list-row" *ngFor="let log of hostLoglist.LogList">
        <td class="color-primary">{{ log.group }}</td>
        <td>{{ log.linkCount }}</td>
        <td>{{ log.owner }}</td>
        <td>{{ log.path }}</td>
        <td>{{ log.permissions }}</td>
        <td>{{ log.size }}</td>
        <td>{{ log.lastModified }}</td>
      </tr>
    </tbody>
  </table>
</div>
